import styled, { device, color } from '@styled'

export const SectionWrapper = styled.section`
  padding-block-start: 10px;
  padding-block-end: 50px;
  ${device.medium} {
    padding-block-end: 70px;
  }
  ${device.large} {
    padding-block-end: 90px;
  }
  ${color}
`

export const StyledText = styled.div`
  margin-block-start: 15px;
  margin-block-end: 25px;
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
  a {
    text-decoration: underline;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow:
    0 1px 4px 0 rgba(0, 0, 0, 0.2),
    0 1px 8px 0 rgba(0, 0, 0, 0.2);
  border: 0px solid rgb(220, 220, 220);
  border-radius: 2px;
  padding: 10px;
  margin-bottom: 30px;
`

export const CardFooter = styled.div`
  color: grey;
  font-size: 12px;
  margin-top: auto;
  padding-left: 12px;
  padding-right: 12px;
`

export const CardText = styled.div`
  color: grey;
  font-size: 16px;
  line-height: 1.5;
  padding-left: 12px;
`

export const CardHeader = styled.div`
  color: rgb(51, 51, 51);
  font-size: 18px;
  font-weight: 800;
  padding-left: calc(var(--bs-gutter-x) * 0.5 + 12px);
  padding-right: calc(var(--bs-gutter-x) * 0.5 + 12px);
  margin-bottom: 30px;
`

export const MenuButton = styled.div`
  color: rgb(51, 51, 51);
  cursor: pointer;
  width: fit-content;
  opacity: 0.6;
  transition: opacity 300ms linear;
  :hover {
    opacity: 1;
    transition: opacity 300ms linear;
  }
`

export const Menu = styled.div`
  @keyframes fadeInAnimation {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  animation: fadeInAnimation ease 500ms;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  right: 0px;
  position: absolute;
  top: 100%;
  border: 1px solid rgb(220, 220, 220);
  min-width: 230px;
  background-color: white;
  padding: 8px;
  z-index: 200;
  text-align: left;
`

export const MenuItem = styled.div`
  cursor: pointer;
  padding: 8px;
  padding-left: 15px;
  background-color: white;
  border-radius: 2px;
  transition: background-color 200ms linear;
  :hover {
    background-color: rgba(178, 201, 211, 0.25);
    transition: background-color 200ms linear;
  }
`
